import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Button, Card, CardBody, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import { getByIdQuotes, quoteStatusUpdate } from 'store/actions';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import * as Yup from "yup"
import { status } from '../../constants/QuoteStatus';
import SelectSearch from 'react-select-search';
import users_details from '../../assets/images/svg/enquiry/user-details.svg'
import shipping_details from '../../assets/images/svg/enquiry/shipping-details.svg'
import container_details from '../../assets/images/svg/enquiry/container-details.svg'
import AuthLoader from 'components/Common/AuthLoader';
import Skeleton from 'react-loading-skeleton';
import PdfView from 'components/Common/PdfView';
import { portData }  from "../../constants/port"

const ViewQuotes = () => {
    document.title = "Enquiry Details | Glottis Logistics";
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [selectedGroup, setselectedGroup] = useState(null)
    const { quote, update, loader } = useSelector(state => ({
        quote: state.GetQuoteById.quote,
        update: state.QuoteStatusUpdate,
        loader: state.GetQuoteById.loading
    }))
    const [previewPdf, setPreviewPdf] = useState(false)
    const [baseFile, setBaseFile] = useState("");
    const [portLoading, setportLoading] = useState("");
    const [portDischarge, setportDischarge] = useState("");
    const { id } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getByIdQuotes(id, history))
    }, [id])
    const viewQuoteForm = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            comment: "",
            status: ''
        },
        validationSchema: Yup.object({
            comment: Yup.string().required("Comment is required"),
            status: Yup.string().nullable().required("Status is required")
        }),
        onSubmit: values => {
            const data = {}
            const resetForm = viewQuoteForm.resetForm();
            if (id) {
                data['comments'] = values.comment
                data['quoteStatus'] = values.status
                data['quoteId'] = id
                dispatch(quoteStatusUpdate(data, resetForm, dispatch, getByIdQuotes, id, history))
            }
        }
    })

    useEffect(() => {
        if (quote) setStatusValue(quote?.quote?.quoteStatus)
        if(quote && quote?.quote?.msdsCertificate) setBaseFile(quote?.quote?.msdsCertificate)
        else setBaseFile('')
    }, [quote])
    function setStatusValue(status) {
        if (status !== 'submitted' && status !== 'draft') {
            setselectedGroup(status);
            viewQuoteForm.setFieldValue("status", status);
        } else {
            setselectedGroup('');
            viewQuoteForm.setFieldValue("status", null);
        }
    } 

    useEffect(() => {
      if (quote) {
        let loading = portData?.filter(
          item => item?.value === quote?.quote?.portOfLoading
        )
        if (loading) setportLoading(loading[0]?.label)
        let discharge = portData?.filter(
          item => item?.value === quote?.quote?.postOfDischarge
        )
        if (discharge) setportDischarge(discharge[0]?.label)
      }
    }, [quote])

    return (
        <div className="page-content quotes-details" >
            <div className="container-fluid view-quote">
                <Breadcrumbs title="Enquiries" dashurl="/quotes" breadcrumbItem={`Enquiry Details: #${quote?.quote?.quoteNumber}`} breadcrumbName="Enquiry Details" />
                <Card className='mt-3'>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={users_details} alt="" />
                            </div>
                            <p className='f-size-16 fw-600 mb-0'>User Details</p>
                        </div>
                        <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Name</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{(quote?.quote?.userDetail?.firstName)}{' '}{(quote?.quote?.userDetail?.lastName)}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Email</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'><a href={`mailto:${"#"}`}>{(quote?.quote?.userDetail?.email)}</a></Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Phone number</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'><a href={`tel:${"#"}`}>{(quote?.quote?.userDetail?.phoneNumber)}</a></Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Client code</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{quote?.quote?.clientDetail?.clientCode}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Client Name</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{quote?.quote?.clientDetail?.name}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                <Card className='mt-3'>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={shipping_details} alt="" />
                            </div>

                            <p className='f-size-16 fw-600 '>Shipping Details</p>
                        </div>
                        <Row>
                            <Col md="8">
                                <Row>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label>Shipping Type</Label>
                                            {!loader ?
                                                <Label className='form-control d-flex align-items-center'>{quote?.quote?.shipmentBy}, {quote?.quote?.shipmentType}</Label> :
                                                <div>
                                                    <Skeleton height={"53px"} width={'100%'} />
                                                </div>
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label>Cargo ready date</Label>
                                            {!loader ?
                                                <Label className='form-control d-flex align-items-center'>{moment(quote?.quote?.cargoReadyDate).format("DD-MM-yyyy")}</Label> :
                                                <div>
                                                    <Skeleton height={"53px"} width={'100%'} />
                                                </div>
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label>Port of loading</Label>
                                            {!loader ?
                                                <Label className='form-control d-flex align-items-center'>{portLoading}</Label> :
                                                <div>
                                                    <Skeleton height={"53px"} width={'100%'} />
                                                </div>
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label>Port of discharge</Label>
                                            {!loader ?
                                                <Label className='form-control d-flex align-items-center'>{portDischarge}</Label> :
                                                <div>
                                                    <Skeleton height={"53px"} width={'100%'} />
                                                </div>
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Commodity</Label>
                                    {!loader ?
                                        <Input type='textarea' className='textarea col-first' disabled value={quote?.quote?.commodity} /> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            {(quote?.quote?.cargoType === 'DG' || quote?.quote?.cargoType === 'REEFER') ? <>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>IMO dg class</Label>
                                        {!loader ?
                                            <Label className='form-control d-flex align-items-center'>{quote?.quote?.imoDGGlass}</Label> :
                                            <div>
                                                <Skeleton height={"53px"} width={'100%'} />
                                            </div>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="mb-3 field-upload">
                                        <Label>MSDS certificate</Label>
                                        {!loader ?
                                            <div className={`upload-field view-file justify-content-between`} >
                                                <div className='d-flex align-items-center' onClick={() => setPreviewPdf(true)}>
                                                    <i className='bx bxs-file-pdf h2 mb-0'></i>
                                                    <p className='mb-0'>MSDS certificate</p>
                                                </div>
                                            </div> :
                                            <div>
                                                <Skeleton height={"53px"} width={'100%'} />
                                            </div>
                                        }
                                    </FormGroup>
                                    <PdfView preview={previewPdf} setPreview={setPreviewPdf} baseFile={baseFile} />
                                </Col>
                                {quote?.quote?.shipmentBy === 'SEA' ?
                                    <>
                                        <Col md="4">
                                            <FormGroup className="mb-3">
                                                <Label>UN number</Label>
                                                {!loader ?
                                                    <Label className='form-control d-flex align-items-center'>{quote?.quote?.unNumber}</Label> :
                                                    <div>
                                                        <Skeleton height={"53px"} width={'100%'} />
                                                    </div>
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup className="mb-3">
                                                <Label>Package code</Label>
                                                {!loader ?
                                                    <Label className='form-control d-flex align-items-center'>{quote?.quote?.packageCode}</Label> :
                                                    <div>
                                                        <Skeleton height={"53px"} width={'100%'} />
                                                    </div>
                                                }
                                            </FormGroup>
                                        </Col>
                                    </> : null
                                }
                            </> : null
                            }
                        </Row>
                    </CardBody>
                </Card>

                <Card>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={container_details} alt="" />
                            </div>
                            <p className='f-size-16 fw-600'>{quote?.quote?.shipmentBy === 'SEA' ? 'Container' : 'Package'} Details</p>
                        </div>
                        <div className='table-responsive react-table'>
                            <table className='container-details-list'>
                                <thead>
                                    <tr>
                                        <th><p className='pb-2'>Cargo type</p></th>
                                        {
                                            quote?.quote?.shipmentBy === 'AIR' ?
                                                <th>
                                                    <p className='pb-2'>Package type</p>
                                                </th> :
                                                <>
                                                    <th>
                                                        <p className='pb-2'>Container type</p>
                                                    </th>
                                                    <th>
                                                        <p className='pb-2'>Container size</p>
                                                    </th>
                                                </>
                                        }
                                        {
                                            quote?.quote?.cargoType !== 'REEFER' ?
                                                <>
                                                    <th><p className='pb-2'>Length(cm)</p></th>
                                                    <th><p className='pb-2'>Width(cm)</p></th>
                                                    <th><p className='pb-2'>Height(cm)</p></th>
                                                </> :
                                                <>
                                                    <th><p className='pb-2'>Temperature(&#8451;)</p></th>
                                                    <th><p className='pb-2'>Humidity(%)</p></th>
                                                    <th><p className='pb-2'>Ventilation(%)</p></th>
                                                </>
                                        }
                                        {quote?.quote?.shipmentBy === 'AIR' ? <th><p className='pb-2'>Weight(kg)</p></th> : <th><p className='pb-2'>Gross weight(kg)</p></th>}
                                        {(quote?.quote?.cargoType === 'REEFER' || quote?.quote?.cargoType === 'ODC') ? null : <th><p className='pb-2'>{quote?.quote?.shipmentBy === 'AIR' ? 'Quantiy' : 'Number of container'}</p></th>}
                                        <th><p className='pb-2'>Net Weight(kg)</p></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quote?.quote?.container?.map((item, index) => (
                                        <tr key={index}>
                                            <td><p>{quote?.quote?.cargoType}</p></td>
                                            {quote?.quote?.shipmentBy === 'AIR' ?
                                                <td><p>{item?.packageType}</p></td> :
                                                <>
                                                    <td><p>{item?.containerType}</p></td>
                                                    <td><p>{item?.containerSize}</p></td>
                                                </>}
                                            {quote?.quote?.cargoType === 'REEFER' ?
                                                <>
                                                    <td><p>{item?.temperature ? item?.temperature : '-'}</p></td>
                                                    <td><p>{item?.humidity ? item?.humidity : '-'}</p></td>
                                                    <td><p>{item?.ventilation ? item?.ventilation : '-'}</p></td>
                                                </> :
                                                <>
                                                    <td><p>{item?.length ? item?.length : '-'}</p></td>
                                                    <td><p>{item?.width ? item?.width : '-'}</p></td>
                                                    <td><p>{item?.height ? item?.height : '-'}</p></td>
                                                </>
                                            }
                                            {quote?.quote?.shipmentBy === 'AIR' ? <td><p>{item?.weight ? item?.weight : '-'}</p></td> : <td><p>{item?.weightPerCargo ? item?.weightPerCargo : '-'}</p></td>}
                                            {(quote?.quote?.cargoType === 'REEFER' || quote?.quote?.cargoType === 'ODC') ? null : <td><p>{item?.noOfContainer ? item?.noOfContainer : '-'}</p></td>}
                                            <td><p>{item?.netWeight ? item?.netWeight : '-'}</p></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
                {((user?.user?.role === 'ADMIN' || user?.user?.role === 'SUPER_ADMIN') && (quote?.quote?.quoteStatus !== 'completed')) ?
                    <Card>
                        <CardBody>
                            <Form
                                className="needs-validation"
                                encType="multipart/form-data"
                                onSubmit={e => {
                                    e.preventDefault()
                                    viewQuoteForm.handleSubmit()
                                    return false
                                }}>
                                <Row>
                                    <Col md={4}>
                                        <p className='mb-2'>
                                            <Label>Current status :</Label> <span className='text-uppercase'>{quote?.quote?.quoteStatus}</span>
                                        </p>
                                    </Col>
                                </Row>
                                {/* current admin comments need to be hide when empty */}
                                {quote?.quote?.comments &&
                                    <Row>
                                        <Col md={4} className='mb-3'>
                                            <p className='mb-0'>
                                                <Label className='mb-0'>Current admin comments :</Label> {quote?.quote?.comments}
                                            </p>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col md="4">
                                        <FormGroup className="mb-3">
                                            <Label>Status<span>*</span></Label>
                                            <div className={`position-relative`}>
                                                <SelectSearch
                                                    options={(status)}
                                                    search={true}
                                                    placeholder="Select quote status"
                                                    name="status"
                                                    value={selectedGroup}
                                                    onChange={(e) => {
                                                        setStatusValue(e)
                                                    }}
                                                    onBlur={viewQuoteForm.handleBlur}
                                                    invalid={
                                                        viewQuoteForm.touched.status && viewQuoteForm.errors.status ? true : false
                                                    }
                                                />
                                                <div className="select-down-arrow">
                                                    <i className="bx bx-chevron-down"></i>
                                                </div>
                                            </div>
                                            {viewQuoteForm.touched.status && viewQuoteForm.errors.status ? (
                                                <span className="role-error invalid-feedback">{viewQuoteForm.errors.status}</span>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Label className='mt-3'>Comments <span>*</span></Label>
                                <Row>
                                    <Col md={4}>
                                        <Input
                                            name="comment"
                                            type="textarea"
                                            className="form-control box-shadow-none"
                                            onChange={viewQuoteForm.handleChange}
                                            onBlur={viewQuoteForm.handleBlur}
                                            value={viewQuoteForm.values.comment || ""}
                                            invalid={viewQuoteForm.touched.comment && viewQuoteForm.errors.comment ? true : false}
                                        />
                                    </Col>
                                </Row>
                                {viewQuoteForm.touched.comment &&
                                    viewQuoteForm.errors.comment ? (
                                    <FormFeedback type="invalid">
                                        {viewQuoteForm.errors.comment}
                                    </FormFeedback>
                                ) : null}
                                <div className='mt-3 d-flex'>
                                    {update.loading === true ? <div className='action-btn-loader me-3'> <AuthLoader /></div> :
                                        <Button type='submit' className='rounded-pill me-3 primary-button '>Submit</Button>}
                                    <Button type='button' onClick={() => history.push('/enquiries')} className='rounded-pill secountry-btn'>Back</Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card> :
                    <div className='my-3 text-center'>
                        <Button type='button' onClick={() => history.push('/enquiries')} className='rounded-pill primary-button'>Back</Button>
                    </div>
                }
            </div>
            <div>

            </div>
        </div >

    )
}

export default ViewQuotes